import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const containerRecipeFn = /* @__PURE__ */ createRecipe('Container', {
  "size": "contained"
}, [])

const containerRecipeVariantMap = {
  "size": [
    "fluid",
    "contained",
    "xs",
    "sm",
    "ms",
    "md",
    "ml",
    "lg",
    "xl",
    "xxl"
  ]
}

const containerRecipeVariantKeys = Object.keys(containerRecipeVariantMap)

export const containerRecipe = /* @__PURE__ */ Object.assign(memo(containerRecipeFn.recipeFn), {
  __recipe__: true,
  __name__: 'containerRecipe',
  __getCompoundVariantCss__: containerRecipeFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: containerRecipeVariantKeys,
  variantMap: containerRecipeVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, containerRecipeVariantKeys)
  },
  getVariantProps: containerRecipeFn.getVariantProps,
})